import clsx from 'clsx';
import React, { Component } from 'react';
import { PropsFunc } from '../../types';
import { navigateBack } from '../../utils/route';
import './index.css';
import { SCENES } from '@/src/pages/address/selector_page/contants';
import lx from '@/src/pages/address/selector_page/statistics';
import { i18nClient } from '@sailor/i18n-mach-pro';
import { $post } from '../../request';

const WMRouter = Mach.requireModule('Router');
const SLCompass = Mach.requireModule('SLCompass');

interface IState {}

interface Props {
  title: string;
  rightComponent?: any;
  visible?: boolean;
  onBack?: PropsFunc;
  regionName?: string;
  scene: number;
  onSkip?: PropsFunc;
}

export default class NavigationBar extends Component<Props, IState> {
  addressSelectPageHorn = false;
  openServiceRegionData: any = undefined;

  constructor(props) {
    super(props);
    this.addressSelectPageHorn = this.getHronConfig();
  }

  pop = () => {
    const { onBack } = this.props;
    if (onBack) {
      onBack();
      return;
    }
    navigateBack();
  };
  noop = () => {}

  componentDidMount() {
    const { scene } = this.props;
    // 首装 灵犀埋点曝光
    if (scene === SCENES.register) {
      lx.firstInstallationBackMv({ address_type: 2 });
      lx.firstInstallationSkipMv({ address_type: 2 });
    }
    // 05.19 下掉接口预请求
    // this.preRequestOpenServiceRegion();
  }

  // 预请求 getOpenServiceRegion 接口，供选择 region 页使用
  preRequestOpenServiceRegion = async () => {
    const [err, res] = await $post<any>({
      url: 'v1/lbs/address/getOpenServiceRegion',
      data: {
        userType: 1,
      },
    });
    if (!err && res) {
      this.openServiceRegionData = res;
    }
  }

  onClickSkip = () => {
    lx.firstInstallationSkipMc({ address_type: 2 });
    const { onSkip } = this.props;
    if (onSkip) {
      onSkip();
    }
  }

  onClickChangeCity = () => {
    lx.changeCityMc();
    const scheme = 'sailorc://keeta.com/machproalert?bundle_name=mach_pro_sailor_c_address_change_region_popup&level=1&mach_use_preset=1';
    const selectData: any = {
      scheme,
      changeLocationReason: 0,
      openServiceRegionData: this.openServiceRegionData,
    };

    // 防止出现意外情况，预请求数据仅使用一次
    this.openServiceRegionData = undefined;

    WMRouter.navigateTo(
      'sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_choose_location_page',
      selectData,
      () => {}
    );
  }

  getHronConfig = () => {
    const regionInfo = SLCompass?.getRegionInfo?.() || {};
    const addressSelectPageNew = regionInfo?.openSARegion?.addressSelectPageNew || false;
    return addressSelectPageNew;
  }

  componentWillUnmount() {

  }

  render() {
    const statusBarHeight = Mach.env.statusBarHeight;
    const { visible = true, regionName } = this.props;
    return (
      <view className={clsx('navbar-container', { hiddle: !visible })} onClick={this.noop}>
        {/* 一定要加这一层 */}
        <view className="container-wrapper" style={{ height: Mach.env.navigationBarHeight + statusBarHeight }}>
          <view style={{ height: statusBarHeight }} />
          <view className="title-container-inner" style={{ height: Mach.env.navigationBarHeight }}>
            <view
              className="left-container"
              onClick={() => this.pop()}
            >
              <view
                className="back-button-container"
                style={{ height: Mach.env.navigationBarHeight }}
              >
                <image src="assets://address/back.png" className="back-button" autoRTL />
              </view>
              <view className="title-text-wrapper">
                <text className="title">{this.props.title}</text>
              </view>
            </view>
            {
              this.props.scene === SCENES.home && this.addressSelectPageHorn ? (
                <view className="title-change-city-container" onClick={this.onClickChangeCity}>
                  <text className="title-change-city" content={regionName || i18nClient.getText('address_addresspage_regionBackup')} />
                  <image className="icon-change-city" src="assets://address/arrow_down.png" />
                </view>
              ) : null
            }
            {
              this.props.scene === SCENES.register && this.addressSelectPageHorn ? (
                <view className="title-skip-container" onClick={this.onClickSkip}>
                  <text className="title-skip" content={i18nClient.getText('Keeta_C_jump_over_u1vN')} />
                </view>
              ) : null
            }
          </view>
        </view>
      </view>
    );
  }
}
